/* globals require window console */
import Vue from "vue";
import { trans } from "common/translate.js";

const POLLING_INTERVAL = 10;
const SLIDE_TIME = 1250;

export default Vue.component("manuscript-result", {
  props: ["name", "copy", "manuscriptId", "thumbnails", "num-images", "num-comments", "manuscript-number", "index"],
  data() {
    return {
      lastFocusTime: 0,
      hasFocus: false,
      timer: null,
      currentSlide: 0,
      previousSlide: this.thumbnails ? this.thumbnails.length - 1 : 0,
      trans
    };
  },

  methods: {
    handleFocus() {
      this.hasFocus = true;
    },

    handleBlur() {
      this.hasFocus = false;
    },

    timeSinceFocus() {
      if (this.hasFocus) {
        return Date.now() - this.lastFocusTime;
      } else {
        return 0;
      }
    },

    startTimer() {
      console.log("Starting timer");
      this.timer = window.setInterval((() => {
        this.currentSlide = Math.floor(this.timeSinceFocus() / SLIDE_TIME) % this.thumbnails.length;
      }).bind(this), POLLING_INTERVAL);
    },

    stopTimer() {
      window.clearInterval(this.timer);
    }
  },

  watch: {
    hasFocus(newVal) {
      if (this.thumbnails) {
        if (newVal) {
          this.lastFocusTime = Date.now();
          this.startTimer();
        } else {
          this.stopTimer();
          this.currentSlide = 0;
        }
      }
    },
    currentSlide(_, oldVal) {
      this.previousSlide = oldVal;
    }
  },

  template: require("./templates/manuscript-result.html")
});



// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/manuscript-result.js